export const fi_FI = {
  customer_type: 'Asiakastyyppi',
  manage_appointment_now: 'Hallinnoi tapaamista nyt',
  maintenance_page_title: 'Calenso-palvelua parannetaan juuri sinulle',
  maintenance_page_subtitle: 'Calenso-palvelua päivitetään uusimpaan versioon. Ole kärsivällinen ja tarkista tilanne muutaman minuutin kuluttua.',
  maintenance_page_button: 'Tilasivulle',
  load_more: 'Lataa lisää',
  show_more: 'Näytä lisää',
  internal_label: 'Sisäinen',
  check_availability_for_anyone: 'Tarkista saatavuus kaikille',
  store_not_found: 'Kauppaa ei löytynyt',
  appointment: 'Tapaamiset',
  event: 'Ryhmätapaamiset',
  resource: 'Resurssit',
  morgen: 'aamu',
  vormittag: 'aamupäivä',
  mittag: 'keskipäivä',
  nachmittag: 'iltapäivä',
  abend: 'ilta',
  nacht: 'yö-',
  free: 'vapaa',
  hoursShort: '',
  minutesShort: 'min',
  mondayLong: 'Maanantai',
  day1: 'MA',
  tuesdayLong: 'Tiistai',
  day2: 'TI',
  wednesdayLong: 'Keskiviikko',
  day3: 'KE',
  thursdayLong: 'Torstai',
  day4: 'TO',
  fridayLong: 'Perjantai',
  day5: 'PE',
  saturdayLong: 'Lauantai',
  day6: 'LA',
  sundayLong: 'Sunnuntai',
  day0: 'SU',
  Januar: 'Tammikuu',
  Februar: 'Helmikuu',
  März: 'Maaliskuu',
  April: 'Huhtikuu',
  Mai: 'Toukokuu',
  Juni: 'Kesäkuu',
  Juli: 'Heinäkuu',
  August: 'Elokuu',
  September: 'Syyskuu',
  Oktober: 'Lokakuu',
  November: 'Marraskuu',
  Dezember: 'Joulukuu',
  "shortMonths": {
    "Januar": "Tam",
    "Februar": "Hel",
    "März": "Maa",
    "April": "Huh",
    "Mai": "Tou",
    "Juni": "Kes",
    "Juli": "Hei",
    "August": "Elo",
    "September": "Syy",
    "Oktober": "Lok",
    "November": "Mar",
    "Dezember": "Jou"
  },
  du: 'sinä',
  sie: 'Sinä',
  havingFormDu: 'omistaa',
  havingFormSie: 'omistaa',
  yes: "Joo",
  no: "Ei",
  timezone: "Aikavyöhyke",
  timezone_partner_hint: "Saatavilla olevat ajat näytetään aikavyöhykkeellä {{timezone}}.",
  confirm: {
    title: 'Vahvista tilaus',
    confirmationText: 'Ostoskorissasi on {{ cartLength }} tapaamisia. Haluatko todella varata ne kaikki nyt?',
    confirmationTextSie: 'Ostoskorissasi on {{ cartLength }} tapaamisia. Haluatko todella varata ne kaikki nyt?',
    ok: 'Kirja',
    cancel: 'Peruuttaa'
  },
  internal: {
    search_customer: 'Hae olemassa olevaa asiakasta ja esitäytä lomake',
    selectPlaceholder: 'Etsi asiakas',
    customerDetails: 'Asiakkaan tiedot',
    noCustomer: 'Asiakkaita ei ole määritetty',
    create_customer: 'Luo asiakas'
  },
  common: {
    report_bug: 'Ilmoita virheestä',
    subscription_error_title: 'Ei tilausta!',
    subscription_error_desc: 'Tilausta ei valitettavasti löytynyt. Ota yhteyttä Calenso-tukeen.',
    next: 'Seuraava',
    previous: 'Edellinen',
    reset: 'Nollaa sovellus',
    resetSuccess: 'Varausohjelmisto nollattiin onnistuneesti. Tilapäisesti tallennetut tiedot ovat nyt poissa.',
    loading: 'Ladataan ...',
    durationHour: 'h',
    durationMinute: 'm',
    clock: 'h',
    disclaimer: 'Tämän palvelun tarjoaa <a href=\'%BRAND_WEBSITE%\' class=\'cal-link\' target=\'_blank\'>Calenso</a>.',
    book: 'Kirja',
    choseBookType: 'Mitä haluaisit varata?',
    company: 'Yhtiö',
    prename: 'Etunimi',
    lastname: 'Sukunimi',
    email: 'Sähköposti',
    phone: 'Puhelin',
    address: 'Osoite',
    createAccount: 'Luo asiakastili (käyttäjätili kaikilla rekisteröinneillä)',
    noDateError: 'Joku muu on varannut haluamasi ajan, palaa takaisin ja valitse uusi aika.',
    devNotice: 'Varauswidget on yhdistetty DEV-taustajärjestelmään. Ole varovainen!',
    store_access_warning: 'Selaimen muistin käyttö on rajoitettu yksityisyysasetustesi vuoksi. Kaikki varaustyökalun toiminnot eivät ehkä ole käytettävissä.',
    save: "Tallenna",
    cancel: "Peruuta",
    additionalParticipantsUpTo: "Voit lisätä jopa {{ number }} vierasta",
    additionalParticipantsUpToOne: "Voit lisätä enintään {{ number }} vieraan",
    additionalGuest: 'Muita osallistujia',
    addAdditionalGuest: 'Lisää osallistujia',
    entryModeIndividual: 'Lisää vieraat yksitellen',
    entryModeAnonymous: 'Anna vain lukumäärä',
    addGuestCount: 'Lisää vieraiden määrä',
    addGuestCountHint: 'Vain määrä — nimiä ei tarvita',
    addParticipantHint: 'Nimi ja yhteystiedot',
    newParticipantTitle: 'Lisää osallistuja',
    editParticipantTitle: 'Muokkaa osallistujaa',
    decrease: 'Vähennä',
    increase: 'Lisää',
    guestCountMaxWarning: 'Tähän aikaan on sallittu enintään {{max}} vierasta.',
    guestCountMaxWarningOne: 'Tähän aikaan on sallittu enintään {{max}} vieras.',
    anonymousGuestCount: 'Kuinka monta vierasta on tulossa?',
    guestCountEditHelper: 'Paikat varataan varauksen yhteydessä — nimiä ei tarvita',
    guestCountHelper: 'Varattu varauksen yhteydessä — nimiä ei tarvita',
    additionalGuestCartLabel: '{{ number }} vieraspaikka',
    additionalGuestsCartLabel: '{{ number }} vieraspaikkaa',
    widget_disabled: 'Varaaminen ei ole tällä hetkellä mahdollista',
    widget_disabled_description: 'Verkkovaraus ei ole tällä hetkellä käytettävissä tälle palveluntarjoajalle. Ota yhteyttä suoraan palveluntarjoajaan sopiaksesi ajan.',
    booking_unavailable: 'Varaaminen ei ole tällä hetkellä mahdollista',
    booking_unavailable_description: 'Verkkovaraus ei ole tällä hetkellä käytettävissä tälle palveluntarjoajalle. Ota yhteyttä suoraan palveluntarjoajaan sopiaksesi ajan.',
    no_workers_widget_disabled_description: 'Aikoja ei voi tällä hetkellä varata, koska mikään resurssi ei ole käytössä.',
    workers_not_available: 'Varattavaa palvelua ei löytynyt',
    workers_not_available_description: 'Varattavissa olevaa palvelua ei tallennettu. Varmista, että vähintään yksi palvelu on saatavilla ja varattavalle resurssille (kyvylle) on määritetty. Palveluluokkaan syöttäminen ei riitä varaamiseen.',
    price_from_label: 'osoitteesta',
    close: 'Sulje',
    configuration_error: 'Konfigurointivirhe',
    resource_is_not_bookable: 'Valittu resurssi ei ole varattavissa.',
    verification_token_missing: 'Varaus-widgettiä käytetään sisäisessä tilassa, ja siksi se vaatii vahvistuskoodin. Ota yhteyttä Calenso-tukeen.',
    invalid_verification_code: 'Sisäisen tilan käyttö vaatii voimassa olevan tunnuksen, varmista että tunnus on voimassa ja yritä uudelleen.',
    internal_appointment_booking_widget_disabled: "Sisäinen widget-palvelu on poistettu käytöstä kumppanin toimesta. Ota yhteyttä järjestelmänvalvojaasi saadaksesi lisätietoja.",
    external_appointment_booking_widget_disabled: "Widget-palvelu on poistettu käytöstä kumppanimme toimesta. Ota heihin yhteyttä saadaksesi lisätietoja.",
    external_event_booking_widget_disabled: "Widget-palvelu on poistettu käytöstä kumppanimme toimesta. Ota heihin yhteyttä saadaksesi lisätietoja.",
    external_pds_booking_widget_disabled: "Ennalta määriteltyjen aikojen varauspalvelu on poistettu käytöstä kumppanimme toimesta. Ota heihin yhteyttä saadaksesi lisätietoja.",
    conference_invalid_link: "Vaikuttaa siltä, että annettu konferenssilinkki on virheellinen. Tarkista linkki ja yritä uudelleen.",
    conference_expired_link: "Pahoittelumme, mutta tämä konferenssilinkki on vanhentunut. Ota yhteyttä järjestäjään saadaksesi lisäapua.",
    conference_not_belonging: "Hups, näyttää siltä, että tämä konferenssi on liitetty eri kumppaniin.",
    conference_booked: "Hupsis, näyttää siltä, että tämä konferenssilinkki on jo käytetty ja varattu. Jos sinulla on kysyttävää tai tarvitset apua, voit vapaasti ottaa yhteyttä järjestäjiin.",
    conference_invalid_configurations: "Konferenssi ei ole käytettävissä virheellisten sisäisten asetusten vuoksi. Saat lisäapua ottamalla yhteyttä järjestäjään.",
    location: "Sijainti",
    empty_string_validation: "Vain välilyönnit eivät ole sallittuja.",
    invalid_password: "Anna kelvollinen salasana.",
    send_otp: "Lähetä OTP",
    resend_otp: "Pyydä uudelleen",
    resend_otp_available_in: "Lähetä OTP uudelleen",
    didnt_receive_otp: "Etkö saanut OTP:tä?",
    ensure_you_have_access_to_your_email_to_receive_the_otp: "Varmista, että sinulla on pääsy sähköpostiisi saadaksesi OTP:n.",
    ensure_you_have_access_to_your_mobile_to_receive_the_otp: "Varmista, että sinulla on pääsy puhelimellesi saadaksesi OTP:n.",
    otp_will_be_sent_to: "Lähetämme yhden kerran salasanan (OTP) sähköpostiisi {{ recipient }}"
  },
  appointments: {
    step1: {
      distance_from_store: '{{ distance }} km päässä',
      search_store_postcode_helper_text: 'Etsi lähin kauppa antamalla postinumero',
      search_services_helper_text: 'Syötä hakusana etsiäksesi palveluita',
      title: 'Palvelut',
      chooseStore: 'Valitse kauppa',
      chooseService: 'Valitse palvelu',
      nextButton: 'Seuraava',
      search_store_by_postcode_placeholder: 'Syötä postinumero etsiäksesi oikean myymälän',
      create_lead: 'Mahdollisuus MH',
      expert_cap_button_label: 'Määrää CAP:n asiantuntijalle',
      appointment_booking_not_available_for_zipcode: 'Valitettavasti ajanvaraus ei ole saatavilla tälle postinumerolle. Luo uusi asiakas, jotta CAP voi ottaa heihin yhteyttä puhelimitse.'
    },
    step2: {
      title: 'Resurssi',
      chooseEmployee: 'Valitse ilmainen resurssi',
      name: 'Nimi',
      function: 'Toiminto',
      noSpecificWorker: 'Kuka tahansa',
      noSpecificFunction: 'Kaikki toiminnot',
      exception: "Määrittele työntekijän poikkeus",
      nextButton: 'Valitse päivämäärä/aika'
    },
    step3: {
      title: 'Päivämäärä',
      chooseDate: 'Valitse haluamasi päivämäärä',
      morning: 'Aamu',
      forenoon: 'Aamupäivä',
      noon: 'Keskipäivä',
      afternoon: 'Iltapäivä',
      evening: 'Ilta',
      night: 'Yö',
      infoMsg: 'Huomaa, että voit valita useita tapaamisia. Valitse vain haluamasi tapaamiset valintaruudun kautta. Ajanvaraukset lisätään sitten ostoskoriin.',
      appointment: 'Tapaaminen',
      employee: 'Resurssi',
      proposals: 'Ilmaiset tapaamiset',
      noFreeAppointments: 'Valitettavasti tälle päivälle ei ole vapaita aikoja!',
      nextButton: 'Seuraava',
      cartNotSupported: 'Tämä palveluntarjoaja tukee vain yhtä slotin rekisteröintiä varausta kohden.',
      cartSupported: 'Tämä palveluntarjoaja tukee useita rekisteröintejä varausta kohden.',
      workerSelectLable: "Valitse Henkilökohtainen Neuvonantaja:",
      workerSelectLinkPrefix: "Etkö löytänyt aikaa neuvonantajasi kanssa?",
      workerSelectShowAllLinkPostfix: "Näytä kaikki neuvonantajat",
      workerSelectHideAllLinkPostfix: "Piilota kaikki neuvonantajat",
      troubleshooting_mode_note_pre: "Puuttuuko aikaväli? Kokeile ",
      troubleshooting_mode_link: "vianmääritystilaa",
      troubleshooting_mode_note_post: " ja saat lisätietoja ei saatavilla olevista aikaväleistä.",
      turn_off_troubleshooting_pre: "Poista ",
      turn_off_troubleshooting_link: "vianmääritystila",
      turn_off_troubleshooting_post: " käytöstä.",
      common_notes: "Yleiset muistiinpanot"
    },
    step4: {
      comment_helper_text: 'Enintään 2000 merkkiä',
      title: 'Viedä loppuun',
      summary: 'Yhteenveto',
      company: 'Yhtiö',
      store: 'Store',
      employee: 'Resurssi',
      bookedServices: 'Palvelu',
      duration: 'Kesto',
      price: 'Hinta',
      finalPrice: 'Kustannukset',
      total: 'Kaikki yhteensä',
      yourData: 'Tietosi',
      disclaimer: 'Ole hyvä ja kirjoita henkilökohtaiset yhteystietosi. Kaikki *-merkityt kentät ovat pakollisia.',
      prename: {
        label: 'Etunimi',
        placeholder: 'Etunimi',
        error: {
          minChars: 'Etunimessä on oltava vähintään {{ requiredLength }} merkkiä.',
          required: 'Lisää etunimi.'
        }
      },
      lastname: {
        label: 'Sukunimi',
        placeholder: 'Sukunimi',
        error: {
          minChars: 'Sukunimessä on oltava vähintään {{ requiredLength }} merkkiä.',
          required: 'Lisää sukunimi.'
        }
      },
      phone: {
        label: 'Kännykkä',
        placeholder: '+4179xxxxxxxx',
        error: {
          pattern: 'Puhelinnumero voi sisältää vain numeroita.',
          minChars: 'Puhelinnumerossa on oltava vähintään {{ requiredLength }} numeroa.',
          required: 'Lisää puhelinnumero.'
        }
      },
      eMail: {
        label: 'Sähköposti',
        error: {
          pattern: 'Lisää kelvollinen sähköpostiosoite.',
          minChars: 'Sähköpostiosoitteessa on oltava vähintään {{ requiredLength }} merkkiä.',
          required: 'Lisää sähköpostiosoite.'
        }
      },
      message: {
        label: 'Viesti',
        placeholder: ''
      },
      internal_comment: {
        label: 'Sisäinen kommentti',
        placeholder: 'Lisää kommentteja sisäiseen käyttöön',
        comment_helper_text: 'Enintään 5000 merkkiä'
      },
      company_name: {
        label: 'Yrityksen nimi',
        error: {
          minChars: 'Tämä kenttä vaatii vähintään {{ requiredLength }} merkkiä.'
        }
      },
      customFields: {
        defaultOption: 'Valitse vaihtoehto',
        error: {
          maxChars: 'Tässä kentässä voi olla enintään {{ requiredLength }} merkkiä.',
          minChars: 'Tämä kenttä vaatii vähintään {{ requiredLength }} merkkiä.',
          required: 'Tämä kenttä on pakollinen.',
          questionisRequired: "{{ text }} on pakollinen",
          checkboxisRequired: "Tämä valintaruutu on valittava, jotta voit jatkaa."
        }
      },
      cart: {
        emptyCartWarning: 'Ostoskorissasi ei ole tällä hetkellä aikoja',
        removeIcon: 'Poista ajanvaraus ostoskorista',
        waiting_list: 'Odotuslista'
      },
      numberSelect: {
        increase: 'Lisää arvoa',
        decrease: 'Vähennä arvoa'
      },
      birthday: {
        label: 'Synttärit',
        error: {
          invalid: 'Syötä kelvollinen synttäripäivä',
          required: 'Syötä sun synttärit.'
        }
      }
    },
    finalpage: {
      successTitle: 'Varasit tapaamisen onnistuneesti',
      successMessageDu: 'Ajanvaraus lähetettiin onnistuneesti. Vahvistus lähetettiin joko sähköpostilla tai tekstiviestillä. <br> <br> Jos et jostain syystä pysty osallistumaan tilaisuuteen, peruuta tilaisuus sähköpostissa tai tekstiviestissä olevan peruutuslinkin kautta.',
      successMessageSie: 'Ajanvaraus lähetettiin onnistuneesti. Vahvistus lähetettiin joko sähköpostilla tai tekstiviestillä. <br> <br> Jos et jostain syystä pysty osallistumaan tilaisuuteen, peruuta tilaisuus sähköpostissa tai tekstiviestissä olevan peruutuslinkin kautta.',
      errorTitle: 'Tapahtui virhe.',
      errorMessage: 'Päivämäärää ei voitu varata. Yritä uudelleen.',
      errorMessageDu: 'Valitettavasti tapaamista ei voitu varata. Yritä uudelleen.',
      errorMessageSie: 'Valitettavasti tapaamista ei voitu varata. Yritä uudelleen.',
      bookNextAppointment: 'Varaa lisäaika',
      bookAppointmentAgain: 'Mene takaisin'
    }
  },
  events: {
    list: "Lista",
    grid: "Ruudukko",
    noEvents: "Tämä palveluntarjoaja ei vielä määrittänyt tapahtumia.",
    hidden_events_message: "Tämän kumppanin tapahtumat ovat piilossa. Käytä rekisteröitymiseen suoraa linkkiä kumppanilta saamaasi tapahtumaan.",
    filter_result_null: "Kriteereitäsi vastaavia tuloksia ei ole.",
    step1: {
      title: "Tapahtumat",
      moreInformation: "Lisää tietoa",
      noFreeSlots: "Ei enää ilmaisia kolikkopelejä",
      noEvents: "Es wurden noch keine Events erstellt.",
      showDescription: "Näytä koko kuvaus",
      hideDescription: "Piilota kuvaus",
      book: "Kirja",
      noPlaceDefined: "Paikkaa ei ole määritelty",
      store_filter: "Tallentaa suodatin",
      category_filter: "Luokan suodatin",
      all_categories: "Kaikki"
    },
    step2: {
      title: 'Päivämäärä',
      slots: 'peliautomaatit',
      chooseDate: 'Valitse haluamasi päivämäärä',
      booked: 'Varattu',
      capacity: 'Saatavilla',
      noFreeDates: 'Tälle kumppanille ei ole ilmaisia tapahtumia',
      bookedOut: 'Tämä paikka on jo varattu',
      cartNotSupported: 'Tämä palveluntarjoaja tukee vain yhtä slotin rekisteröintiä varausta kohden.',
      cartSupported: 'Tämä palveluntarjoaja tukee useita rekisteröintejä varausta kohden.',
      alreadyBookedByUser: 'Olet jo varannut tämän paikan. Jos ongelmia ilmenee, nollaa sovellus.',
      waitinglist: 'jonotuslista: {{ capacity }} ilmainen',
      fully_booked: "Täysin varattu",
      regular_count_singular: '<b>1</b> vapaa paikka',
      regular_count_plural: '<b>{{ number }}</b> vapaata paikkaa',
      waiting_count_singular: "1 vapaa paikka jonotuslistalla",
      waiting_count_plural: "{{ number }} vapaata paikkaa jonotuslistalla",
      free_seats: 'Vapaat paikat',
      free_waiting_seats: 'Ilmaiset odotuslistapaikat',
      multiday_group_appointment: "Tämä on monipäiväinen ryhmätapaaminen"
    },
    step3: {
      title: 'Viimeistele',
      summary: 'Yhteenveto',
      company: 'Yhtiö',
      store: 'Store',
      employee: 'Resurssi',
      bookedEvent: 'Tapahtuma',
      date: 'Päivämäärä',
      time: 'Aika',
      price: 'Hinta',
      finalPrice: 'Kustannukset',
      total: 'Kaikki yhteensä',
      yourData: 'Tietosi',
      disclaimer: 'Anna yhteystietosi. Kaikki *-merkityt kentät ovat pakollisia.',
      cart: {
        emptyCartWarning: 'Ostoskorissa ei ole tällä hetkellä tapahtumia.',
        waiting_list: 'Odotuslista'
      }
    },
    finalpage: {
      successTitle: 'Ilmoittautuminen onnistui.',
      successMessageDu: 'Ilmoittautuminen tapahtumaan onnistui. Vahvistus lähetettiin joko sähköpostilla tai tekstiviestillä. <br> <br> Jos et jostain syystä pysty osallistumaan tilaisuuteen, peruuta tilaisuus sähköpostissa tai tekstiviestissä olevan peruutuslinkin kautta.',
      successMessageSie: 'Ilmoittautuminen tapahtumaan onnistui. Vahvistus lähetettiin joko sähköpostilla tai tekstiviestillä. <br> <br> Jos et jostain syystä pysty osallistumaan tilaisuuteen, peruuta tilaisuus sähköpostissa tai tekstiviestissä olevan peruutuslinkin kautta.',
      errorTitle: 'Tapahtui virhe.',
      errorMessage: 'Rekisteröinnin aikana tapahtui virhe. Yritä uudelleen.',
      bookNextEvent: 'Varaa lisäilmoittautuminen',
      bookEventAgain: 'Mene takaisin'
    }
  },
  resources: {
    noResources: 'Tämä palveluntarjoaja ei vielä määrittänyt resursseja.',
    step1: {
      title: 'Resurssit',
      chooseResource: 'Valitse Resurssit'
    },
    step2: {
      title: 'Päivämäärä',
      startDate: 'Aloituspäivämäärä: ',
      endDate: 'Päättymispäivä: ',
      startTime: 'Valitse aloitusaika',
      endTime: 'Valitse lopetusaika',
      resetCalendar: 'Nollaa kalenteri',
      noFreeResources: 'Varattavia resursseja ei löytynyt ajanjaksolle',
      selectDate: 'Valitse päivämäärä tai ajanjakso'
    },
    step3: {
      title: 'Viedä loppuun',
      summary: 'Yhteenveto',
      company: 'Yhtiö',
      store: 'Store',
      employee: 'Resurssi',
      bookedEvent: 'Tapahtuma',
      date: 'Päivämäärä',
      time: 'Aika',
      price: 'Hinta',
      finalPrice: 'Kustannukset',
      total: 'Kaikki yhteensä',
      yourData: 'Tietosi',
      disclaimer: 'Anna yhteystietosi. Kaikki *-merkityt kentät ovat pakollisia.',
      prename: {
        label: 'Etunimi',
        placeholder: 'Etunimi',
        error: {
          minChars: 'Etunimen on oltava vähintään {{ requiredLength }} merkkiä pitkä.',
          required: 'Ilmoita etunimi.'
        }
      },
      lastname: {
        label: 'Sukunimi',
        placeholder: 'Sukunimi',
        error: {
          minChars: 'Sukunimen on oltava vähintään {{ requiredLength }} merkkiä pitkä.',
          required: 'Anna sukunimi.'
        }
      },
      phone: {
        label: 'Matkapuhelin',
        placeholder: '+4179xxxxxxxx',
        error: {
          pattern: 'Puhelinnumero voi sisältää vain numeroita.',
          minChars: 'Puhelinnumeron on oltava vähintään {{ requiredLength }} Sisältää merkkejä.',
          required: 'Anna puhelinnumero.'
        }
      },
      eMail: {
        label: 'sähköposti',
        error: {
          pattern: 'Ole hyvä ja syötä toimiva sähköpostiosoite.',
          minChars: 'Sähköpostiosoitteen on oltava vähintään {{ requiredLength }} merkkiä pitkä.',
          required: 'Ole hyvä ja syötä sähköpostiosoite.'
        }
      },
      message: {
        label: 'Viesti',
        placeholder: ''
      },
      customFields: {
        defaultOption: 'Valitse mikä tahansa vaihtoehto',
        error: {
          minChars: 'Tämä kenttä vaatii {{ requiredLength }} merkkiä.',
          required: 'Tämä kenttä on pakollinen.'
        }
      },
      cart: {
        emptyCartWarning: 'Ostoskorissa ei ole tällä hetkellä resursseja.'
      },
      From: 'Lähettäjä',
      To: 'Vastaanottaja'
    },
    finalpage: {
      successTitle: 'Varasit onnistuneesti resurssin',
      successMessageDU: 'Jos muutat mieltäsi, peruuta resurssivarauksesi vähintään {{ leadTime }} tuntia ennen varauksen tekemistä.',
      successMessageSIE: 'Jos muutat mieltäsi, peruuta resurssivarauksesi vähintään {{ leadTime }} tuntia ennen varauksen tekemistä.',
      errorTitle: 'Tapahtui virhe.',
      errorMessage: 'Resurssia ei voitu varata. Yritä uudelleen.',
      bookNextEvent: 'Varaa lisäresursseja',
      bookEventAgain: 'Mene takaisin'
    }
  },
  customer: {
    prename: {
      label: 'Etunimi',
      placeholder: 'Etunimi',
      error: {
        minChars: 'Etunimen on oltava vähintään {{ requiredLength }} merkkiä pitkä.',
        required: 'Kirjoita etunimesi, ole hyvä.'
      }
    },
    lastname: {
      label: 'Sukunimi',
      placeholder: 'Sukunimi',
      error: {
        minChars: 'Sukunimen on oltava vähintään {{ requiredLength }} merkkiä pitkä.',
        required: 'Anna sukunimesi.'
      }
    },
    phone: {
      label: 'Puhelinnumero',
      placeholder: '+4179......',
      error: {
        pattern: 'Puhelinnumerossa saa olla vain numeroita.',
        minChars: 'Puhelinnumerossa on oltava vähintään {{ requiredLength }} numeroa.',
        required: 'Ole hyvä ja anna puhelinnumerosi.',
        invalid: 'Anna voimassa oleva matkapuhelinnumero.'
      }
    },
    eMail: {
      label: 'Sähköposti',
      error: {
        pattern: 'Ole hyvä ja syötä toimiva sähköpostiosoite.',
        minChars: 'Sähköpostiosoitteessa on oltava vähintään {{ requiredLength }} merkkiä.',
        required: 'Sähköpostiosoite vaaditaan.'
      }
    },
    street: {
      label: 'Katu / nro.',
      placeholder: 'Kadun nimi',
      error: {
        minChars: 'Kadun tulee sisältää vähintään {{ requiredLength }} merkkiä.',
        required: 'Anna kadun nimi.'
      }
    },
    zip: {
      label: 'POSTINUMERO',
      placeholder: 'Postinumero',
      error: {
        minChars: 'Postinumerossa on oltava vähintään {{ requiredLength }} merkkiä.',
        required: 'Anna postinumerosi.',
        pattern: "Anna kelvollinen postinumero, kiitos.",
      }
    },
    city: {
      label: 'Kaupunki',
      placeholder: 'kaupungin nimi',
      error: {
        minChars: 'Kaupungissa on oltava vähintään {{ requiredLength }} merkkiä.',
        required: 'Anna kaupunkisi nimi.'
      }
    },
    message: {
      label: 'Viesti',
      placeholder: ''
    },
    customFields: {
      defaultOption: 'Valitse vaihtoehto',
      error: {
        minChars: 'Tämä kenttä vaatii vähintään {{ requiredLength }} merkkiä.',
        required: 'Tämä kenttä pitää täyttää.'
      }
    },
    captcha: {
      required: 'Tämä kenttä pitää täyttää.',
      invalid: 'Syötä kelvollinen captcha.',
      valid: 'Captcha sovitettu onnistuneesti.',
      placeholder: 'Kirjoita yllä oleva teksti'
    }
  },
  stripe: {
    stripe_title: 'Maksa seuraava vierailusi verkossa',
    submit_payment: 'Lähetä maksu',
    stripe_label: 'Luottokortti tai pankkikortti',
    online_payment_optional: 'Tässä vaiheessa sinulla on mahdollisuus päättää seuraava vierailusi juuri nyt. Sinulta ei peritä lisäkuluja. Maksu suoritetaan suojatun palveluntarjoajan (Stripe) kautta. Emme tallenna luottokorttitietoja palvelimillemme.',
    online_payment_mandatory: 'Varauksen viimeistelemiseksi pyydämme sinua maksamaan seuraavan vierailusi nyt. Sinulta ei peritä lisäkuluja. Maksu suoritetaan suojatun palveluntarjoajan (Stripe) kautta. Emme tallenna luottokorttitietoja palvelimillemme.'
  },
  alert_messages: {
    select_day_in_calendar_msg: "Valitse tietty päivä kalenterista nähdäksesi mahdolliset päivämäärät.",
    no_events_in_month: "Valitettavasti valitussa kuukaudessa ei ole enää vapaita aikoja.",
    no_events: "Valitettavasti tällä tapahtumalla ei ole varattavissa olevia ikkunoita tulevaisuudessa. Siksi kalenteria ei näytetä päivämäärän valitsemiseksi.",
    waitinglist_enabled_message: "Jotkin aikavälien paikat on jo varattu täyteen. Jonotuslistalle voi kuitenkin ilmoittautua. Heti kun osallistuminen peruuntuu, seuraava jonotuslistan paikka nousee ylöspäin ja saa vahvistuksen osallistumisesta.",
    waitinglist_booking_message: "Paljon kiitoksia! Olemme hyväksyneet varauksesi onnistuneesti. Koska olet nyt jonotuslistalla ainakin yhteen tapahtumaan, saat meiltä vain vahvistuksen osallistumisestasi, jos toinen osallistuja ei pääse tapahtumaan. Tässä tapauksessa sinulle ilmoitetaan sähköpostitse. Valitettavasti tilanpuutteen vuoksi et pääse tapahtumaan ilman virallista vahvistusta sivustoltamme.",
    window_is_fully_booked: "Tämä aikaikkuna on täynnä (mukaan lukien jonotuslista).",
    singular_waitinglist_is_available: "Tämä aikaväli on täynnä, mutta sillä on vielä <b>{{ number }}</b> vapaa paikka jonotuslistalla.",
    plural_waitinglist_is_available: "Tämä aikaväli on täynnä, mutta sillä on vielä <b>{{ number }}</b> vapaata paikkaa jonotuslistalla.",
    no_bookable_dates_message: "Valitettavasti kuukaudessa {{ month }} ei ole enää varattavia päiviä. Pitäisikö meidän etsiä vapaita päivämääriä tulevina kuukausina?",
    no_slots_dates_message: "Valitettavasti kuukaudessa {{ month }} ei ole enää varattavissa olevia aikoja. Pitäisikö meidän etsiä tulevina kuukausina vapaita aikoja?",
    no_slots_dates_reached_message: "Valitettavasti kuukaudessa {{ month }} ei ole enää varattavissa olevia aikoja. Enimmäisvarausaika on saavutettu.",
    no_slots_years_reached_message: "Valitettavasti vuoden {{ year }} kaikki varattavat ajat on jo varattu. Varattavissa oleva aika on täyttynyt.",
    no_bookable_dates_reached_message: "Valitettavasti kuukaudessa {{ month }} ei ole enää varattavia päivämääriä. Enimmäisvarausaika on saavutettu.",
    xss_error_message: "Tämä teksti sisältää HTML-tageja, joita ei tueta.",
    slot_already_reserved_by_other_error: "Sillä välin varaamasi aika on varattu jonkun toisen toimesta. Valitse toinen aika ja yritä myöhemmin uudelleen.",
    failed_to_reserve_slot_error: "Jokin meni pieleen varauksen aikana. Yritä myöhemmin uudelleen!",
    reserved_by_someone: "Varattu jonkun toisen toimesta",
    next_step_error_customer_type: 'Valitse asiakastyyppi jatkaaksesi.',
    next_step_error_service: 'Valitse palvelu jatkaaksesi.',
    next_step_error_worker: 'Valitse resurssi jatkaaksesi.',
    next_step_error_meeting_type: 'Valitse, missä tapaaminen tulisi järjestää, jatkaaksesi.',
    next_step_error_date: 'Valitse päivämäärä ja aikaikkuna jatkaaksesi.',
  },
  coupon_credit_card_info: {
    redeem_coupon_1: 'Lunasta kuponki',
    apply_coupon: 'Käytä kuponki',
    coupon: 'Kuponki',
    credit_or_debit_card: 'Luotto- tai pankkikortti',
    invalid_coupon: 'Virheellinen kuponki',
    applied_successfully: 'Sovellettu onnistuneesti',
    insufficient_balance_error: "Kupongissa ei ole riittävästi saldoa lunastukseen.",
    coupon_email_required_error: "Kelvollinen sähköpostiosoite vaaditaan sen käyttämiseksi.",
    coupon_applied_remaining_balance: "Käytetty onnistuneesti. Kupongin käytön jälkeen jäljelle jäävä saldo on {{ currency }} {{ amount }}."
  },
  tax_info: {
    taxes: "ALV",
    inclusive: "sis.",
    exclude: "ei sis.",
    plus: "plus",
    net_total: "Yhteensä",
    tax_line: "Lisäksi ALV {{percentage}}%:",
    amount_incl_tax: "Summa sis. ALV",
    tax_included_line: "Hintaan sisältyvä ALV {{percentage}}%:",
    amount_excl_tax: "Summa ilman ALV"
  },
  new_alert_component: {
    x_day_ago: 'x päivä sitten',
    x_days_ago: 'x päivää sitten',
    x_minute_ago: 'x minuutti sitten',
    x_minutes_ago: 'x minuuttia sitten',
    x_hour_ago: 'x tunti sitten',
    x_hours_ago: 'x tuntia sitten',
    x_second_ago: 'x sekunti sitten',
    x_seconds_ago: 'x sekuntia sitten',
    x_week_ago: 'x viikko sitten',
    x_weeks_ago: 'x viikkoa sitten',
    x_month_ago: 'x kuukausi sitten',
    x_months_ago: 'x kuukautta sitten',
    x_year_ago: 'x vuosi sitten',
    x_years_ago: 'x vuotta sitten'
  },
  adyen: {
    payment_method_label: 'Luotto- tai pankkikortti',
    retry: 'Yritä uudelleen',
    loading: 'Ladataan maksutapoja…',
    hosted: {
      pay_button: 'Maksa kortilla',
      hint: 'Adyenin suojattu maksuikkuna avautuu.',
      waiting: 'Viimeistele maksu Adyen-ikkunassa.',
      popup_blocked: 'Selain esti maksuikkunan. Salli ponnahdusikkunat tälle sivulle ja valitse "Maksa kortilla" uudelleen.',
      return_hint: 'Suljettiinko maksuikkuna tai katosiko se?',
      complete_payment: 'Viimeistele maksu',
      returned_elsewhere_title: 'Maksu vastaanotettu',
      returned_elsewhere: 'Palaa välilehdelle, jolla aloitit varauksen - varaus viimeistellään siellä. Älä maksa uudelleen tällä sivulla. Jos suljit sen välilehden, mitään ei varattu ja maksusi palautetaan automaattisesti tunnin kuluessa.',
      start_new_booking: 'Aloita uusi varaus',
    },
    errors: {
      session_failed: 'Maksua ei voitu aloittaa. Yritä uudelleen.',
      refused: 'Maksu hylättiin. Valitse toinen maksutapa.',
      cancelled: 'Peruutit maksun.',
      pending: 'Maksu ei ole vielä valmis. Maksaaksesi uudelleen valitse "Yritä uudelleen" tai valitse toinen maksutapa, jos sellainen on tarjolla.',
      unexpected: 'Maksussa tapahtui virhe. Yritä uudelleen.',
      nothing_to_pay: 'Tästä varauksesta ei ole mitään maksettavaa.',
      unavailable: 'Korttimaksu ei ole käytettävissä tälle varaukselle. Valitse toinen maksutapa.',
      booking_refused: 'Korttimaksuasi ei voitu vahvistaa, joten mitään ei varattu. Yritä uudelleen.',
      temporarily_unavailable: 'Korttimaksu ei ole tilapäisesti käytettävissä. Yritä hetken kuluttua uudelleen.',
      context_changed: 'Varauksesi muuttui maksun aikana, joten mitään ei varattu. Jo tehty maksu palautetaan automaattisesti. Tarkista valintasi ja maksa uudelleen.',
      already_booked: 'Tämä varaus on jo tehty maksullasi. Tarkista vahvistussähköpostisi. Jos haluat varata uudelleen, valitse "Yritä uudelleen".',
      expired: 'Maksuistunto on vanhentunut. Yritä uudelleen.',
      session_expired: 'Maksuistuntosi vanheni, joten mitään ei varattu. Mahdollisesti veloitettu summa palautetaan automaattisesti. Yritä uudelleen.',
      resume_unavailable: 'Selaimesi ei salli palaamista tähän varaukseen. Maksa Adyenin suojatussa ikkunassa ja pidä tämä sivu auki.',
    },
  },
  summary_page_translations: {
    paypal_warning_msg: 'Ennen kuin varaus on mahdollista, avoin summa on maksettava PayPalilla.',
    paypal: 'PayPal',
    paypal_paid_successfully: 'Summa maksettiin onnistuneesti PayPalilla. Ajan voi nyt varata.',
    paypal_paid_failed: 'Valitettavasti summaa ei voitu maksaa PayPalilla. Ota yhteyttä Calenso-tukeen.',
    or: 'tai',
    browser: 'Selaa',
    choose_file: 'Valitse tiedosto',
    clear: 'Asia selvä',
    meeting_type: 'Missä tapaaminen tulisi järjestää?',
    email: 'Sähköposti',
    sms: 'tekstiviesti',
    both_sms_email: 'Sähköposti ja SMS',
    notification_type: 'Ilmoituksen tyyppi',
    payment_title: 'Maksu',
    payment_subtitle: 'Päätä, kuinka haluat maksaa palveluistasi',
    payment_subtitle_sie: 'Päätä, kuinka haluat maksaa palveluistasi',
    summary_title: 'Yhteenveto',
    summary_subtitle: 'Tarkista tilauksesi ja lähetä se',
    summary_subtitle_sie: 'Tarkista tilauksesi ja lähetä se',
    payment_type: 'Maksutapa',
    creditcard: 'Luottokortti',
    invoice: 'Lasku',
    external_invoice: 'Maksu laskulla',
    external_invoice_different_address: 'Käytä eri laskutusosoitetta',
    invoice_address_title: 'Laskutusosoite',
    invoice_address_street_error: 'Anna katuosoite ja talon numero (esim. Bahnhofstrasse 12).',
    lexoffice: 'Lasku (LexOffice)',
    store: 'Sivulla',
    apply_coupon: 'Haluaisin käyttää alennuskoodia',
    choose_payment_method: 'Valitse maksutapa',
    other_payment_options: 'Muut maksutavat',
    subtotal: 'Välisumma',
    personal_form_title: 'Henkilökohtaiset tiedot',
    personal_form_subtitle: 'Kerro meille jotain sinusta',
    personal_form_subtitle_sie: 'Kerro meille jotain sinusta',
    inclusive: 'mukaan lukien',
    paymentMandatory: 'Palveluntarjoaja on määritellyt, että palvelu on maksettava verkossa etukäteen. Valitse siis maksutapa.',
    file_upload: 'Tiedoston lataus',
    file_upload_helper_text: 'Useita tiedostoja voidaan liittää',
    file_was_uploaded: '"{{name}}" lähetettiin onnistuneesti',
    max_file_size_5mb: 'Ladattu tiedosto on liian suuri (enintään 5 Mt sallittu).',
    malware_found: 'Virustarkistuksessa ilmeni ongelma (Pääsy estetty). Ota yhteyttä Calenso-tukeen!',
    multiple_file_upload_helper_text: 'Enintään 5 tiedostoa voidaan ladata. Ladattava tiedosto ei saa olla suurempi kuin 5 Mt.',
    file_uploading: 'Tiedoston lataus on vielä kesken. Odota, kunnes toiminto on päättynyt, ja yritä sitten varata uudelleen..',
    single_file_upload_helper_text: '1 tiedosto voidaan ladata. Ladattava tiedosto ei saa olla suurempi kuin 5 Mt.',
    maximum_x_files: 'Enintään {{fileLength}} tiedostoa voidaan ladata.',
    document_invalid_file_type: "Virheellinen tiedostotyyppi. Vain PDF- ja Excel-tiedostot ovat sallittuja.",
    image_invalid_file_type: "Virheellinen tiedostotyyppi, lataa kelvollinen kuvatiedosto.",
    request_sms_code: 'Varauskoodi',
    mobile_number_must_be_verified: 'Puhelinnumero on onnistuneesti vahvistettu.',
    verification_code: 'Vahvistuskoodi',
    sms_code_verification_failed_msg: 'Syötetty koodi ei valitettavasti vastaa tekstiviestillä lähettämäämme koodia.',
    check: 'Tarkistaa',
    phone_number_verified_successfully: 'Puhelinnumero on vahvistettu.',
    resend_sms_helper_msg_1: 'En ole saanut koodia.',
    resend_sms_helper_msg_2: 'Pyydä koodi uudelleen.',
    resend_sms_successfully: 'Tekstiviestikoodi lähetetty onnistuneesti',
    exceeded_sms_verification_limit_msg: 'Tämä numero on ylittänyt vahvistuskoodien enimmäismäärän. Ota yhteyttä Calenso-tukeen (<a href="mailto:%BRAND_SUPPORT_EMAIL%">%BRAND_SUPPORT_EMAIL%</a>).',
    salutation: 'Tervehdys',
    mr: 'Herra',
    ms: 'Neiti',
    other: 'muu',
    select_payment_method: 'Valitse maksusyy',
    payment_method_required: 'Valitse maksutapa ja suorita maksu loppuun lähettääksesi varauksen.',
    accept_data_policy: 'Hyväksyn ja olen lukenut <a href="%BRAND_TERMS_URL%" target="_blank">Calenso-käyttöehdot</a> ja <a href="%BRAND_PRIVACY_URL%" target="_blank">Tietosuojakäytäntö</a> tietojeni käyttöön tapaamisen varauksen yhteydessä.',
    saferpay: 'Saferpay',
    saferpay_pay: 'Napauta maksaaksesi Saferpayn avulla',
    payment_success_title: 'Onnistunut maksu',
    payment_success_message: 'Avoin summa on maksettu onnistuneesti {{ paymentMethod }}. Ajanvaraus voidaan nyt varata. Jos varausta ei ole tehty, summaa ei veloiteta..',
    title: 'Otsikko',
    country: 'Maa',
    title_aria_describedby: "Erityinen arvo, joka tukee tohtori, tohtori. med., Prof. ja Prof. Dr.",
    salutation_aria_describedby: "Tervehdysmuoto, joka tukee Herra, Rouva ja muita",
    prename_aria_describedby: "Etunimi",
    lastname_aria_describedby: "Sukunimi",
    notification_type_aria_describedby: "Voit määrittää varaustapahtuman aikana, miten haluat saada ilmoituksen varauksesta.",
    email_describedby: "Sähköposti",
    phoneNumber_aria_describedby: "Puhelinnumero",
    smsPhoneCode_aria_describedby: "OTP puhelinnumeron vahvistamiseksi",
    mobileNumber_aria_describedby: "Matkapuhelinnumero",
    smsMobileCode_aria_describedby: "OTP matkapuhelinnumeron vahvistamiseksi",
    street_aria_describedby: "Osoite",
    zip_aria_describedby: "Postinumero",
    city_aria_describedby: "Kaupunki",
    country_aria_describedby: "Maa",
    comment_aria_describedby: "Lisäkommentit, jos sinulla on",
    internal_comment_aria_describedby: "Sisäinen kommentti (vain sisäiseen käyttöön)",
    company_aria_describedby: "Yrityksen nimi",
    captcha_aria_describedby: "Captcha",
    too_many_requests_exception: "Liian monta pyyntöä. Vedä henkeä ja yritä joskus myöhemmin.",
    block_for_minute: "Liikaa pyyntöjä. Odota {{ time }} minuutti ennen kuin teet lisäpyyntöjä.",
    block_for_minutes: "Liikaa pyyntöjä. Odota {{ time }} minuuttia ennen kuin teet lisäpyyntöjä.",
    block_for_second: "Liian monta pyyntöä. Odota {{ time }} sekunti ennen lisäpyyntöjen tekemistä.",
    block_for_seconds: "Liian monta pyyntöä. Odota {{ time }} sekuntia ennen lisäpyyntöjen tekemistä.",
    sufficient_permissions_missing: "Sulta puuttuu oikeudet tän tekemiseen"
  },
  buttons: {
    yes_search: 'Kyllä, etsi.',
    remove: 'Poista'
  },
  add: 'Lisätä',
  compact: {
    no_service: 'Tällä hetkellä ei voida varata tapaamisia, koska vastaavaa palvelua ei ole löydetty.',
    navigation: {
      date: 'Päivämäärä',
      date_slots: 'Päivämäärä ja kellonaika',
      personal_info: 'Henkilökohtaiset tiedot'
    }
  },
  reservation_timer: {
    reservation_expired_tooltip: 'Tämä aikaikkuna ei välttämättä ole enää saatavilla. Valitse uusi aikaikkuna.',
    reservation_expired: 'Varausaikasi on päättynyt',
    reservation_time_remaining_tooltip: 'Tämä aikaikkuna on varattu sinulle. Ole hyvä ja viimeistele varauksesi jäljellä olevassa ajassa, muuten se voi tulla muiden käyttäjien saataville.',
    reservation_time_remaining: 'Varausaika: {{ time }} minuuttia',
    reservation_expired_booking_blocked: 'Varauksesi on vanhentunut. Palaa takaisin ja valitse uusi aika.',
    reservation_expired_payment_refunded: 'Varauksesi on vanhentunut, joten mitään ei varattu. Maksusi palautetaan automaattisesti tunnin kuluessa. Palaa takaisin ja valitse uusi aika.',
  },
  error_messages: {
    invalid_configuration: 'Virheellinen konfiguraatio, ota yhteyttä tukeen.',
    reached_max_limit: 'Yritit jo tarpeeksi monta kertaa. Kokeile uudestaan!',
    something_went_wrong: 'Jokin meni pieleen, yritä uudelleen myöhemmin.',
    invalid_otp: 'Virheellinen OTP'
  },
  payment_components: {
    refundNotice: 'Maksusi on käsitelty, mutta varausta ei voitu viimeistellä. Veloitettu summa palautetaan 24 tunnin kuluessa. Jos näin ei tapahdu, ota yhteyttä tukeen ja jaa tapahtumatunnus {{transactionId}}, jotta voimme auttaa sinua nopeammin.',
    bookingOutcomeUnknownNotice: 'Emme saaneet vastausta ennen varauksesi vahvistamista, joten se on voinut onnistua tai jäädä tekemättä. Tarkista sähköpostistasi varausvahvistus ennen kuin maksat uudelleen. Jos sitä ei tule muutamassa minuutissa, ota yhteyttä tukeen ja jaa tapahtumatunnus {{transactionId}}.',
    bookingOutcomeUnknownError: 'Emme voineet vahvistaa varaustasi. Tarkista sähköpostisi ennen kuin maksat uudelleen.',
    paymentSessionSpentError: 'Tätä maksua ei voi enää käyttää uuteen varaukseen. Tarkista sähköpostisi ennen kuin maksat uudelleen.',
    paymentSessionSpentNotice: 'Tätä maksua ei voi enää käyttää uuteen varaukseen. Tarkista sähköpostisi: jos sait varausvahvistuksen, varauksesi on olemassa, etkä saa maksaa uudelleen. Muussa tapauksessa aloita uusi maksu. Jos tarvitset apua, ota yhteyttä tukeen ja jaa tapahtumatunnus {{transactionId}}.',
    paymentAlreadyBookedNotice: 'Varauksesi on jo vahvistettu tällä maksulla. Tarkista sähköpostistasi varausvahvistus äläkä maksa uudelleen. Jos tarvitset apua, ota yhteyttä tukeen ja jaa tapahtumatunnus {{transactionId}}.',
    bookingStillCompletingError: 'Viimeistelemme varaustasi. Tarkista sähköpostistasi varausvahvistus ennen kuin yrität uudelleen.',
    bookingStillCompletingNotice: 'Viimeistelemme varaustasi tällä maksulla. Tarkista sähköpostistasi varausvahvistus ennen kuin yrität uudelleen, äläkä maksa uudelleen. Jos vahvistusta ei tule muutaman minuutin kuluessa, ota yhteyttä tukeen ja jaa tapahtumatunnus {{transactionId}}.',
    complete_payment_first: 'Suorita maksu ennen varaamista.',
    pay_again: 'Maksa uudelleen',
    form_incomplete: 'Täytä kaikki pakolliset kentät ennen maksuun siirtymistä.',
    cancel_payment: 'Peruuta maksu',
    payment_in_progress: 'Maksu on käynnissä – suorita maksu loppuun tai peruuta se.',
    stripe_not_ready: 'Maksulomake ei ole vielä valmis. Odota hetki ja yritä uudelleen.',
    payment_processing_error: 'Maksua ei voitu käsitellä. Yritä uudelleen.',
  },
  pre_defined_slots: {
    select_slot_title: 'Valitse aikaikkuna',
    select_slot_description: 'Valitse vapaana oleva aikaikkuna varauksellesi.',
    list_view: 'Lista',
    calendar_view: 'Kalenteri',
    no_slots_available: 'Vapaita aikaikkunoita ei löytynyt.',
    no_services_available: 'Varattavia palveluita ei ole tällä hetkellä saatavilla. Ota yhteyttä järjestelmänvalvojaan.',
    next_button: 'Seuraava',
    previous_button: 'Takaisin',
    book_button: 'Varaa nyt',
    personal_data_title: 'Henkilötiedot',
    personal_data_description: 'Syötä henkilötietosi.',
    summary_title: 'Yhteenveto',
    slot_details: 'Aikaikkunan tiedot',
    personal_info: 'Henkilötiedot',
    title_label: 'Otsikko',
    date_label: 'Päivämäärä',
    time_label: 'Aika',
    service_label: 'Palvelu',
    location_label: 'Sijainti',
    name_label: 'Nimi',
    email_label: 'Sähköposti',
    phone_label: 'Puhelin',
    booking_error_title: 'Varaus epäonnistui',
    booking_failed: 'Varausta ei voitu suorittaa. Yritä uudelleen.',
    slot_already_booked: 'Tämän aikaikkunan on jo varannut toinen henkilö. Valitse toinen aikaikkuna.',
    try_again_button: 'Yritä uudelleen',
    select_service_title: 'Valitse palvelu',
    select_service_description: 'Valitse palvelu nähdäksesi saatavilla olevat aikaikkunat.',
    slots_available: 'aikaikkunaa saatavilla',
    feature_unavailable_title: 'Toiminto ei ole käytettävissä',
    feature_unavailable_message: 'Resurssien suunnittelu ei ole käytössä tälle kumppanille. Ota yhteyttä järjestelmänvalvojaan.',
  },
  pre_defined_slot: 'Ennalta määritetyt ajat',
  tour_widget: {
    time_overview: 'Aikakatsaus',
    max_duration: 'Enintään {{hours}} tuntia kierrosta kohden',
    total_duration: 'Kokonaiskesto',
    visit_time: 'Vierailuaika',
    travel_time: 'Matka-aika',
    travel_time_pill: '{{min}} min. matka-aika',
    selected_route: 'Valittu reitti',
    no_selection: 'Ei vielä valittuja tehtaita',
    book_tour: 'Varaa kierros',
    minutes_short: 'min.',
    error_exceeds_max: 'Kierros ylittää sallitun keston — poista pysäkki.',
    error_feature_not_available: 'Tämä ominaisuus ei sisälly tilaukseesi.',
    error_no_services_configured: 'Kierrokselle ei ole vielä määritetty pysäkkejä. Ota yhteyttä järjestäjään.',
    error_generic: 'Jotain meni vikaan. Yritä uudelleen.',
    upcoming_absences_badge: 'Huolto suunniteltu',
    upcoming_absences_dialog_title: 'Tuleva huolto',
    upcoming_absences_dialog_close: 'Sulje',
    upcoming_absences_all_day: 'Koko päivän',
  },
};
